<script lang="ts">
import FicheVirementsEmis from '@/generated/fiches/FicheVirementsEmis.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FicheVirementsEmis
})

</script>
